(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jqf-event-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jqf-event-reel')) {
    class JqfEventReel extends HTMLElement {
      connectedCallback() {
        this.reel = this.querySelector('[data-reel]');
        if (!this.reel) return;
        this.videos = Array.from(this.querySelectorAll('video[data-src]'));
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reduce;
        this.motionBtn = this.querySelector('[data-motion]');

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));

        if (this.motionBtn) {
          if (this.reduce || this.videos.length === 0) {
            this.motionBtn.hidden = true;
          } else {
            this.motionBtn.addEventListener('click', () => this.toggleMotion());
          }
        }

        if (this.reduce || !('IntersectionObserver' in window)) return;

        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            v._visible = entry.isIntersecting && entry.intersectionRatio >= 0.4;
            if (v._visible) this.play(v);
            else if (!v.paused) v.pause();
          });
        }, { threshold: [0, 0.4, 0.75] });
        this.videos.forEach((v) => this.io.observe(v));
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }

      play(v) {
        if (this.paused) return;
        if (!v.src && v.dataset.src) {
          v.src = v.dataset.src;
          v.load();
        }
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }

      toggleMotion() {
        this.paused = !this.paused;
        this.motionBtn.setAttribute('aria-pressed', String(this.paused));
        const label = this.motionBtn.querySelector('[data-motion-label]');
        if (label) label.textContent = this.paused ? 'Play clips' : 'Pause clips';
        this.videos.forEach((v) => {
          if (this.paused) v.pause();
          else if (v._visible) this.play(v);
        });
      }

      step(dir) {
        const card = this.reel.querySelector('.jqf-event__card');
        const gap = parseFloat(getComputedStyle(this.reel).columnGap) || 16;
        const amount = card ? card.getBoundingClientRect().width + gap : this.reel.clientWidth * 0.8;
        this.reel.scrollBy({ left: dir * amount, behavior: this.reduce ? 'auto' : 'smooth' });
      }
    }
    customElements.define('jqf-event-reel', JqfEventReel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jqf-showcase-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jqf-showcase')) {
    class JqfShowcase extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.slides = [...this.querySelectorAll('[role="tabpanel"]')];
        if (!this.tabs.length) return;
        this.index = 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;
        this.toggleAttribute('data-playing', this.autoplay);

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.go(i, true));
          tab.querySelector('.jqf-show__bar span')?.addEventListener('animationend', () => {
            if (i === this.index && this.autoplay) this.go((this.index + 1) % this.slides.length);
          });
        });

        this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
          const n = this.slides.length;
          let next = null;
          if (e.key === 'ArrowRight') next = (this.index + 1) % n;
          if (e.key === 'ArrowLeft') next = (this.index - 1 + n) % n;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = n - 1;
          if (next !== null) {
            e.preventDefault();
            this.go(next, true);
            this.tabs[next].focus();
          }
        });

        const pause = () => this.setAttribute('data-paused', '');
        const resume = () => this.removeAttribute('data-paused');
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(); });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') resume(); });
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) resume(); });

        const stage = this.querySelector('.jqf-show__stage');
        let x0 = null;
        let y0 = null;
        stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
        stage.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0;
          const dy = e.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            const n = this.slides.length;
            this.go(dx < 0 ? (this.index + 1) % n : (this.index - 1 + n) % n, true);
          }
        });

        // Theme editor: show the block being edited.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i > -1) { this.go(i, true); pause(); }
        });
        document.addEventListener('shopify:block:deselect', resume);

        this.restartBar();
      }

      go(i, byUser = false) {
        if (i === this.index && !byUser) return;
        this.index = i;
        this.slides.forEach((s, n) => {
          const on = n === i;
          s.classList.toggle('is-active', on);
          s.toggleAttribute('inert', !on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.tabs.forEach((t, n) => {
          const on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.restartBar();
        // Keep the active tab visible when the tab row scrolls (phones).
        const tab = this.tabs[i];
        const row = tab.parentElement;
        if (row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      restartBar() {
        const bar = this.tabs[this.index]?.querySelector('.jqf-show__bar span');
        if (!bar) return;
        bar.style.animation = 'none';
        void bar.offsetWidth;
        bar.style.animation = '';
      }
    }
    customElements.define('jqf-showcase', JqfShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
